<template>
  <div class="w-full px-3 sticky top-0">
    <h2 class="font-bold text-18px pb-0.5 py-3">Summary</h2>
    <div v-if="campaign">
      <SummaryCard label="Budget">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#money`"></use>
          </svg>
        </template>
        <span>{{ flight?.budget ? `&euro;${flight?.budget}` : '-' }}</span>
      </SummaryCard>
      <SummaryCard label="CPM">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#money`"></use>
          </svg>
        </template>
        <span>{{ campaign?.cpm ? `&euro;${campaign?.cpm}` : '-' }}</span>
      </SummaryCard>
      <SummaryCard label="Period">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#calendar`"></use>
          </svg>
        </template>
        <span>{{ period }}</span>
      </SummaryCard>
      <SummaryCard label="Impressions">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#eyeImp`"></use>
          </svg>
        </template>
        <div v-if="flight?.budget" class="w-[87px] flex justify-between items-center">
          <div class="w-[48px] h-[4px] rounded bg-gray"></div>
          <span> {{ impressions }}</span>
        </div>
        <span v-else> {{ impressions }}</span>
      </SummaryCard>
      <SummaryCard label="Assets">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#doc`"></use>
          </svg>
        </template>
        <span>{{ flight?.assets?.length || '-' }}</span>
      </SummaryCard>
      <SummaryCard label="Creatives">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#files`"></use>
          </svg>
        </template>
        <span>-</span>
      </SummaryCard>
      <SummaryCard label="Screenshots">
        <template slot="icon">
          <svg width="16" height="17">
            <use :xlink:href="`#screen`"></use>
          </svg>
        </template>
        <span>-</span>
      </SummaryCard>
    </div>
  </div>
</template>
<script>
import { evaluate } from 'mathjs'
import { mapGetters } from 'vuex'
import SummaryCard from '@/components/social-products/social-boost/parts/SummaryCard.vue'
import { FormatDate } from '@/utils'

export default {
  name: 'FlightSummary',
  components: {
    SummaryCard,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    flight() {
      return this.campaign?.flights?.find((f) => f.id === Number(this.$route.params.flight_id))
    },
    period() {
      if (this.flight?.start_date && this.flight?.end_date) {
        return `${FormatDate(this.flight.start_date, this.flight.end_date)}`
      }
      return '-'
    },
    impressions() {
      const formula = '(budget / CPM) * 1000'
      if (this.flight?.budget && this.campaign?.cpm) {
        const impresions = evaluate(formula, { budget: this.flight.budget, CPM: this.campaign.cpm })
        var formatted = this.$numbro(impresions).format({
          average: true,
          thousandSeparated: true,
          mantissa: 1,
          roundingFunction: Math.floor,
        })

        formatted = formatted.replace(/([a-z])$/, (m) => m.toUpperCase())

        return formatted
      } else {
        return '-'
      }
    },
  },
}
</script>
